import React from 'react';
import cn from 'classnames';

import { Icon, Portal } from 'components';
import SettingsMobileOverlay from '../../SettingsMobileOverlay';
import useSettingsButtonMobile from './useSettingsButtonMobile';

import settingsIcon from 'assets/svg/setting-betslip.svg';
import './settingsButtonMobile.scss';

const SettingsButtonMobile = () => {
    const {
        isOpened,
        toggleModal,
        container,
        modalContainer,
    } = useSettingsButtonMobile();

    return (
        <div styleName="container" ref={container}>
            <Icon
                styleName={cn('icon', {
                    'is-open': isOpened,
                })}
                glyph={settingsIcon}
                onClick={toggleModal}
            />
            {isOpened && (
                <Portal>
                    <SettingsMobileOverlay container={modalContainer} />
                </Portal>
            )}
        </div>
    );
};

export default React.memo(SettingsButtonMobile);
